// This file can be replaced during build by using the `fileReplacements` array.
// `ng build` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  demo: "default",
  ABN_API_KEY: "be07c8c9-7905-48ee-862e-20ad60efbbee",
  DEBOUCE_TIME: 250,
  // API_URL: "https://tec.arrobabit.com",
  // SOAP_URL: 'https://suporte.arrobabit.com/customerportal_Trybe.php',
  API_URL: "https://teste-tickets.expandbss.online",
  SOAP_URL: 'https://teste.expandbss.online/customerportal_Trybe.php',
  // API_URL: "https://escdig-tec.expandbss.online",
  // SOAP_URL: 'https://escdig.expandbss.online/customerportal_trybe.php',
  // API_URL: "http://localhost:4200",
  // SOAP_URL: 'http://172.22.128.1/customerportal_Trybe.php',
};

// API_URL: "http://localhost:4200",
/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/plugins/zone-error';  // Included with Angular CLI.
